import { Component, OnInit } from '@angular/core';
import { IPortfolioItem } from '../portfolio-item/portfolio-item.model';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css'],
})
export class PortfolioComponent implements OnInit {
  public items: Array<IPortfolioItem> = [
    {
      title: 'Soundboard',
      description:
        'A soundboard program written in Python to turn a Raspberry Pi with a keyboard into a configurable soundboard. Each key press plays a different sound, with key combinations to switch the set of sounds being used. Supports text-to-speech. Also has volume control and the ability for some minor audio manipulation. This was built as a present for my son who loves pushing buttons that do things. It also was an excuse for me to learn Python.',
      url: 'https://github.com/turbidwater/soundboard',
      imageUrl: 'assets/soundboard.png',
    },
    {
      title: 'Commute Tracker',
      description:
        'I wanted to track how long taking different routes on my commute fared over time. In order to do that, I built an Android application that used geolocation to track this. I incorporated voice commands for hands free interactions. It was built with ActionScript, Flex, and Java. The Java part was creating Android Native Extensions for sending long emails and detecting the geo capabilities available. I also even made the logo in Illustrator.',
      url: 'https://play.google.com/store/apps/details?id=air.com.turbidwater.commutetracker.CommuteTrackerFlex',
      imageUrl: 'assets/commuteTracker.png',
    },
    {
      title: 'The Life of God in the Soul of Man',
      description:
        "I made two copies of the book <a href='https://books.google.com/books?id=BncAAAAAMAAJ&dq=%22the+life+of+god+in+the+soul+of+man%22&pg=PP1&ots=2pQKVDjpM8&sig=y-blfgv3r6rcu2S-Awj2YGtWyuU&hl=en&prev=http://www.google.com/search%3Fq%3D%2522the%2Blife%2Bof%2Bgod%2Bin%2Bthe%2Bsoul%2Bof%2Bman%2522%2B%26ie%3Dutf-8%26oe%3Dutf-8%26rls%3Dorg.mozilla:en-US:official%26client%3Dfirefox-a&sa=X&oi=print&ct=title#v=onepage&q=%22the%20life%20of%20god%20in%20the%20soul%20of%20man%22&f=false'>The Life of God in the Soul of Man</a> by Henry Scougal. When I say I made them, I really did. I typeset the books, printed them, built the cases, sewed the signatures together and made the physical book. The text is a public domain book from the 1600s that was inspiration for the book called The Pleasures of God by John Piper. This was made as a gift for my wife.",
      url: 'http://www.turbidwater.com/portfolio/downloads/TheLifeOfGodInTheSoulOfMan.pdf',
      imageUrl: 'assets/lifeOfGod.png',
    },
    {
      title: 'The Little Book of Origins',
      description:
        'I made a book from scratch for an Advanced Typography class. It is more of an art book exploring two different systems of thought on how our current world came to be. I created the images and content for book, typeset it, and physically created the book. <a href="http://www.turbidwater.com/portfolio/lboo/creation.htm">This site</a> serves as a companion for the book. It displays the evolution of the creative process of the book.',
      url: 'http://www.turbidwater.com/portfolio/lboo/creation.htm',
      imageUrl: 'assets/lboo.png',
    },
    {
      title: 'Ragnars Saga Loðbrokar',
      description:
        "The translation of an Icelandic edda by Chris VanDyke. The story is about a family of crazy warriors. It involves war cows, boneless archers, armor made from wooly breeches, and SPOILER: death by snake pit. I typeset and bound 3 copies of the book, which contains among other things, a glossary of proper names and many, many translator's notes. This is the non-impositioned PDF of the text.",
      url: 'http://www.turbidwater.com/portfolio/downloads/RagnarsSaga.pdf',
      imageUrl: 'assets/ragnar.png',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
